import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateOrderDocumentPayload, createOrderDocument } from '~/services/OrderDocumentService';

import { orderDocumentQueryKeys } from './useGetOrderDocuments';

interface UseCreateOrderDocumentOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}
interface CreateOrderDocumentParams {
  orderId: string;
  payload: CreateOrderDocumentPayload;
}
export function useCreateOrderDocument({ onSuccess, onError }: UseCreateOrderDocumentOptions = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ orderId, payload }: CreateOrderDocumentParams) => {
      if (!orderId) {
        throw new Error('Missing order id');
      }
      return createOrderDocument(orderId, payload);
    },
    onSuccess: async (orderDocument: { result: { order_id: string } }) => {
      const orderId = orderDocument.result.order_id;
      if (orderId) {
        await queryClient.invalidateQueries({ queryKey: orderDocumentQueryKeys.list(orderId) });
      }
      onSuccess?.();
    },
    onError,
  });
}
